<template>
    <form class="h-full w-full flex flex-col p-8" @submit.prevent="submitForm">
        <transition name="rsdfade" mode="out-in">
            <div key="1" ref="tab1" v-if="selectedTab == 1" class="h-full w-full flex flex-col">
                <div class="grid grid-cols-2 gap-6">
                    <div v-if="mode == 'edit'" class="flex flex-col form-input" :class="{ invalid: !groupName.isValid }">
                        <label for="groupName">Name of Position</label>
                        <div class="border rounded-lg py-2 px-2 cursor-not-allowed">{{ selectedItem.job.position_name }}</div>
                    </div>
                    <div v-else class="flex flex-col form-input" :class="{ invalid: !groupName.isValid }">
                        <label for="groupName">Name of Position</label>
                        <select v-model.trim="groupName.val" @blur="clearValidity('groupName')" class="ht-42">
                            <option value="">Select a position</option>
                            <option v-for="(item, index) in nameOfPositions" :key="index" :value="item.id">{{ getNameOfPosition(item) }}</option>
                        </select>
                        <transition name="fade" mode="out-in">
                            <p v-if="!groupName.isValid" class="h-4 text-xs text-red-600">
                                {{ groupName.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !fieldOfJob.isValid }">
                        <label for="fieldOfJob">Select the field of job</label>
                        <input
                            type="text"
                            id="fieldOfJob"
                            v-model.trim="fieldOfJob.val"
                            placeholder=""
                            @blur="clearValidity('fieldOfJob')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!fieldOfJob.isValid" class="h-4 text-xs text-red-600">
                                {{ fieldOfJob.msg }}
                            </p>
                        </transition>
                    </div>
                    <!-- <div class="flex flex-col form-input" :class="{ invalid: !interviewDateTime.isValid }">
                        <label for="interviewDateTime">Set interview scheduling: Start Date & Time</label>
                        <input
                            type="datetime-local"
                            id="interviewDateTime"
                            v-model.trim="interviewDateTime.val"
                            placeholder=""
                            @blur="clearValidity('interviewDateTime')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!interviewDateTime.isValid" class="h-4 text-xs text-red-600">
                                {{ interviewDateTime.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !interviewEndDateTime.isValid }">
                        <label for="interviewEndDateTime">Set interview scheduling: End Date & Time</label>
                        <input
                            type="datetime-local"
                            id="interviewEndDateTime"
                            v-model.trim="interviewEndDateTime.val"
                            placeholder=""
                            @blur="clearValidity('interviewEndDateTime')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!interviewEndDateTime.isValid" class="h-4 text-xs text-red-600">
                                {{ interviewEndDateTime.msg }}
                            </p>
                        </transition>
                    </div> -->
                    <div class="flex flex-col form-input" :class="{ invalid: !interviewThrough.isValid }">
                        <label for="interviewThrough">Interview Type</label>
                        <select class="ht-42" id="interviewThrough" v-model.trim="interviewThrough.val" placeholder="" @blur="clearValidity('interviewThrough')">
                            <option value="">Select an option</option>
                            <option value="in-person interview">in-person interview</option>
                            <option value="phone interview">phone interview</option>
                            <option value="virtual interview">virtual interview</option>
                        </select>
                        <transition name="fade" mode="out-in">
                            <p v-if="!interviewThrough.isValid" class="h-4 text-xs text-red-600">
                                {{ interviewThrough.msg }}
                            </p>
                        </transition>
                    </div>
                    <div v-if="showLocation" class="flex flex-col form-input" :class="{ invalid: !location.isValid }">
                        <label for="location">Interview Location</label>
                        <input
                            type="text"
                            id="location"
                            v-model.trim="location.val"
                            placeholder=""
                            @blur="clearValidity('location')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!location.isValid" class="h-4 text-xs text-red-600">
                                {{ location.msg }}
                            </p>
                        </transition>
                    </div>
                    <div v-if="showMeetingLink" class="flex flex-col form-input" :class="{ invalid: !meetingLink.isValid }">
                        <label for="meetingLink">Meeting Link</label>
                        <input
                            type="text"
                            id="meetingLink"
                            v-model.trim="meetingLink.val"
                            placeholder=""
                            @blur="clearValidity('meetingLink')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!meetingLink.isValid" class="h-4 text-xs text-red-600">
                                {{ meetingLink.msg }}
                            </p>
                        </transition>
                    </div>
                </div>
                <!-- <div class="mt-6 grid grid-cols-2 gap-6">
                    <div class="flex flex-col" :class="{ invalid: !supervisor.isValid }">
                        <label for="supervisor">Supervisor</label>
                        <input
                            type="text"
                            id="supervisor"
                            v-model.trim="supervisor.val"
                            placeholder=""
                            @blur="clearValidity('supervisor')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!supervisor.isValid" class="h-4 text-xs text-red-600">
                                {{ supervisor.msg }}
                            </p>
                        </transition>
                    </div>
                </div> -->
                <div class="mt-6 flex flex-col">
                    <label for="select-students">Select Candidates</label>
                    <div class="flex flex-col border min-ht-44 rounded-t-md" :class="showDropDown ? '' : 'rounded-b-md'">
                        <div>
                            <input v-model="search" type="text" placeholder="Type to search" class="w-full rounded-t-md rounded-b-md p-2 outline-none" @focus="showDropDown = true">
                        </div>
                        <div v-if="selectedCandidates.length > 0" class="flex justify-start flex-wrap p-2 max-ht-224 overflow-y-auto">
                            <div v-for="(item, index) in selectedCandidates" :key="index" class="flex items-center bg-green-600 px-2 py-1 rounded-md mr-2 mb-2">
                                <div class="text-white text-sm">{{ item.fullname }}</div>
                                <div class="ml-2">
                                    <svg @click.stop="removeCandidate(item.id)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="w-3 h-3 text-gray-600 hover:text-white cursor-pointer">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="showDropDown" class="h-56 border border-t-0 rounded-b-md overflow-y-auto">
                        <div v-for="(item, index) in filteredApprovedCandidates" :key="index" :class="item.is_selected ? 'bg-green-600 cursor-not-allowed' : ''" class="px-4 py-2 hover:bg-gray-600 hover:text-white" @click.stop="addCandidate(item)">
                            <div class="flex justify-between items-center">
                                <div>{{ item.fullname }} - {{ item.student_id }}</div>
                                <div class="flex-shrink-0 flex justify-start items-center">
                                    <div class="ml-4">
                                        <icon-eye @click.stop="viewStudentProfile(item.student_id)" class="w-4 h-4 transform hover:scale-110 cursor-pointer"></icon-eye>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                        <p v-if="!selectedCandidatesIsValid" class="h-4 text-xs text-red-600">
                            {{ selectedCandidatesIsValidMsg }}
                        </p>
                    </transition>
                </div>
                <div class="w-full flex justify-end mt-8">
                    <div @click.stop="goToNextTab" class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">Next</div>
                </div>
            </div>
            <div key="2" v-else class="h-full w-full flex flex-col" :style="getStyle">
                <div class="flex-auto flex flex-col overflow-y-auto">
                    <div class="text-gray-600 text-xl font-medium">Schedule the interview</div>
                    <div class="flex flex-col">
                        <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                                <div class="overflow-hidden">
                                    <table class="min-w-full border text-center text-sm font-light">
                                        <thead class="border-b font-medium bg-primary text-white">
                                            <tr>
                                                <th
                                                    scope="col"
                                                    class="border-r px-6 py-4">
                                                    #
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-r px-6 py-4">
                                                    Student Name
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-r px-6 py-4">
                                                    Start Date & Time
                                                </th>
                                                <th scope="col" class="px-6 py-4">End Date & Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in selectedCandidates" :key="index" class="border-b">
                                                <td class="whitespace-nowrap border-r px-6 py-4 font-medium">
                                                    {{ index + 1 }}
                                                </td>
                                                <td class="whitespace-nowrap border-r px-6 py-4">
                                                    {{ item.fullname }}
                                                </td>
                                                <td class="whitespace-nowrap border-r px-6 py-4">
                                                    <input
                                                        type="datetime-local"
                                                        id="interviewDateTime"
                                                        v-model.trim="item.start_date_and_time"
                                                        class="outline-none"
                                                        @blur="clearValidity('interviewDateTime')"
                                                    />
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-4">
                                                    <input
                                                        type="datetime-local"
                                                        id="interviewDateTime"
                                                        v-model.trim="item.end_date_and_time"
                                                        class="outline-none"
                                                        @blur="clearValidity('interviewDateTime')"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                        <p v-if="!scheduleInterviewDatesisValid" class="h-4 text-xs text-red-600">
                            {{ scheduleInterviewDatesMsg }}
                        </p>
                    </transition>
                </div>
                <div class="w-full flex justify-between items-center mt-8">
                    <div @click.stop="goToPrevTab" class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">Back</div>
                    <div v-if="isLoading" class="w-36 bg-gradient-to-r from-primary to-secondaryLight px-4 py-2 rounded-lg text-white flex items-center justify-center">
                        <base-spinner-with-text class-list="h-6 w-6 text-white capitalize" :text="getLoadingBtnText" text-class-list="text-white"></base-spinner-with-text>
                    </div>
                    <button v-else class="w-36 bg-gradient-to-r from-primary hover:from-white to-secondaryLight hover:to-white px-4 py-2 rounded-lg text-white hover:text-secondaryLight border border-secondaryLight">{{ getBtnText }}</button>
                </div>
            </div>
        </transition>
    </form>
</template>

<script>
import gql from 'graphql-tag';
import IconEye from "../../../components/icons/IconEye.vue";
export default {
    name: "interview-form",
    components: { IconEye, },
    emits: ["created", "updated", "close", "view-student-profile"],
    props: ["mode", "selectedItem", "candidates"],
    data() {
        return {
            selectedCandidates: [],
            selectedCandidatesIsValid: true,
            selectedCandidatesIsValidMsg: "",
            groupName: {
                val: "",
                isValid: true,
                msg: "",
            },
            interviewDateTime: {
                val: null,
                isValid: true,
                msg: "",
            },
            interviewEndDateTime: {
                val: null,
                isValid: true,
                msg: "",
            },
            fieldOfJob: {
                val: "",
                isValid: true,
                msg: "",
            },
            interviewThrough: {
                val: "",
                isValid: true,
                msg: "",
            },
            location: {
                val: "",
                isValid: true,
                msg: "",
            },
            meetingLink: {
                val: "",
                isValid: true,
                msg: "",
            },
            supervisor: {
                val: "",
                isValid: true,
                msg: "",
            },
            formIsValid: true,
            isLoading: false,
            error: null,
            approvedCount: null,
            nameOfPositions: [],
            approvedCandidates: [],
            search: "",
            showDropDown: false,
            selectedTab: 1,
            scheduleInterviewDatesisValid: true,
            scheduleInterviewDatesMsg: "",
        };
    },
    created() {
        if (this.mode == 'edit') {
            this.setFormData();
        }
    },
    watch: {
        'groupName.val': function(newVal) {
            if (newVal) {
                this.fetchJobApplicationCandidates(newVal);
            }
        },
    },
    computed: {
        getBtnText() {
            if (this.mode == 'create') {
                return "Create";
            } else {
                return "Update";
            }
        },
        getLoadingBtnText() {
            if (this.mode == 'create') {
                return "Creating...";
            } else {
                return "Updating...";
            }
        },
        showMeetingLink() {
            if (this.interviewThrough.val == 'virtual interview') {
                return true;
            } else {
                return false;
            }
        },
        showLocation() {
            if (this.interviewThrough.val == 'in-person interview') {
                return true;
            } else {
                return false;
            }
        },
        partnerId() {
            return this.$store.getters.partner_id;
        },
        filteredApprovedCandidates() {
            return this.approvedCandidates.filter(user =>
                user.fullname.toLowerCase().includes(this.search.toLowerCase())
            );
        },
        getStyle() {
            const divElement = this.$refs.tab1;
            if (divElement) {
                const divHeight = divElement.clientHeight;
                return `height: ${divHeight}px;`;
            } else {
                return "height: 594px;";
            }
        },
    },
    apollo: {
        nameOfPositions() {
            return {
                query: gql`query GetNameOfPositions($partner_id: Int!) {
                    nameOfPositions(partner_id: $partner_id) {
                        id
                        job_title
                        position_name
                    }
                }`,
                variables () {
                    return {
                        partner_id: parseInt(this.partnerId),
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        goToNextTab() {
            if (this.selectedTab == 1) {
                this.validateForm1();
                if (!this.formIsValid) {
                    return;
                }
                this.selectedTab = 2;
            }
        },
        goToPrevTab() {
            this.selectedTab = 1;
        },
        clearValidity(input) {
            this[input].isValid = true;
            this[input].msg = "";
        },
        validateForm1() {
            this.formIsValid = true;
            
            if (this.groupName.val === "") {
                this.groupName.isValid = false;
                this.groupName.msg = "Group Name must not be empty.";
                this.formIsValid = false;
            }

            if (this.interviewThrough.val === "") {
                this.interviewThrough.isValid = false;
                this.interviewThrough.msg = "You must select an Interview Type.";
                this.formIsValid = false;
            }

            if (this.selectedCandidates.length == 0) {
                this.selectedCandidatesIsValid = false;
                this.selectedCandidatesIsValidMsg = "You must select atleast 1 candidate";
                this.formIsValid = false;
            }
        
            
        },
        validateForm2() {
            this.formIsValid = true;
            this.scheduleInterviewDatesisValid = true;
            this.scheduleInterviewDatesMsg = "";
            for (const item of this.selectedCandidates) {
                const startDateIsNull = item.start_date_and_time === null;
                const endDateIsNull = item.end_date_and_time === null;
                if (startDateIsNull || endDateIsNull) {
                    this.formIsValid = false;
                    this.scheduleInterviewDatesisValid = false;
                    this.scheduleInterviewDatesMsg = "Please fill out all the dates";
                    break;
                }
            }
        },
        async submitForm() {

            this.validateForm2();
            if (!this.formIsValid) {
                return;
            }

            const selectedNameOfPosition = this.nameOfPositions.find(obj => obj.id == this.groupName.val);
            const groupName = selectedNameOfPosition.position_name;

            const formData = {
                job_id: parseInt(this.groupName.val),
                group_name: groupName,
                interview_date_time: this.interviewDateTime.val,
                interview_end_date_time: this.interviewEndDateTime.val,
                field_of_job: this.fieldOfJob.val,
                interview_through: this.interviewThrough.val,
                location: this.location.val,
                supervisor: this.supervisor.val,
                meeting_link: this.meetingLink.val,
                selected_candidates: this.selectedCandidates,
            };

            const CREATE_MUTATION = gql`
                mutation CreateInterview($input: CreateInterviewInput!) {
                    createInterview(input: $input) {
                        error
                        message
                    }
                }
            `;

            const UPDATE_MUTATION = gql`
                mutation UpdateInterview($id: ID!, $input: CreateInterviewInput!) {
                    updateInterview(id: $id, input: $input) {
                        error
                        message
                    }
                }
            `;

            this.isLoading = true;

            try {
                await this.$apollo.mutate({
                    mutation: this.mode == 'create' ? CREATE_MUTATION : UPDATE_MUTATION,
                    variables: {
                        id: this.mode == 'edit' ? this.selectedItem.id : null,
                        input: formData
                    }
                }).then((data) => {
                    if (this.mode == 'create') {
                        if (data.data.createInterview.error) {
                            this.error = data.data.createInterview.message;
                        }
                    } else {
                        if (data.data.updateInterview.error) {
                            this.error = data.data.updateInterview.message;
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                })

            } catch (error) {
                console.log(error);
                this.error = error.message || "Failed to authenticate, try later.";
            }

            if (this.error === null) {
                if (this.mode == 'create') {
                    this.$emit('created');
                } else {
                    this.$emit('updated');
                }
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: this.error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.$emit('close');
                    }
                })
            }

            this.isLoading = false;

        },
        setFormData() {
            this.selectedCandidates = this.selectedItem.interview_candidates.map((item) => {
                return {
                    id: parseInt(item.user.id),
                    email: item.user.email,
                    fullname: `${item.user.name}`,
                    start_date_and_time: item.start_date_and_time,
                    end_date_and_time: item.end_date_and_time,
                }
            });

            this.groupName.val = this.selectedItem.job_id;
            this.fieldOfJob.val = this.selectedItem.field_of_job;
            this.interviewDateTime.val = null;
            this.interviewEndDateTime.val = null;
            this.interviewThrough.val = this.selectedItem.interview_through;
            this.location.val = this.selectedItem.location;
            this.supervisor.val = this.selectedItem.supervisor;
            this.meetingLink.val = this.selectedItem.meeting_link;
        },
        async fetchJobApplicationCandidates(jobId) {
            
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query FetchJobApplicationCandidates($job_id: Int!, $is_approved: Boolean!) {
                            fetchJobApplicationCandidates(job_id: $job_id, is_approved: $is_approved) {
                                data {
                                    user {
                                        id
                                        name
                                        email
                                        students {
                                            student_id
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        job_id: parseInt(jobId),
                        is_approved: true,
                    },
                    fetchPolicy: 'network-only',
                });

                this.approvedCandidates = data.fetchJobApplicationCandidates.data.map(application => {
                    const user = application.user;
                    return {
                        id: parseInt(user.id),
                        fullname: user.name,
                        email: user.email,
                        student_id: user.students.student_id,
                        is_selected: false,
                    };
                });

                if (this.mode == 'edit') {
                    this.approvedCandidates.forEach(aItem => {
                        const matchingBItem = this.selectedCandidates.find(bItem => bItem.id === aItem.id);

                        if (matchingBItem) {
                            aItem.is_selected = true;
                        }
                    });
                }

            } catch (error) {
                console.error(error);
            }
            
        },
        viewStudentProfile(studentId) {
           this.$emit('view-student-profile', studentId);
        },
        addCandidate(user) {

            const index = this.approvedCandidates.findIndex(item => item.id === user.id);

            if (index !== -1) {
                if (!this.approvedCandidates[index].is_selected) {
                    const selectedUser = {
                        id: user.id,
                        email: user.email,
                        fullname: user.fullname,
                        start_date_and_time: null,
                        end_date_and_time: null,
                    };
                    this.selectedCandidates.push(selectedUser);
                    this.approvedCandidates[index].is_selected = true;

                    this.selectedCandidatesIsValid = true;
                    this.selectedCandidatesIsValidMsg = "";

                }
            } else {
                console.log('User not found in approvedCandidates');
            }
        },
        removeCandidate(userId) {
            const index = this.selectedCandidates.findIndex(item => item.id === userId);
            if (index !== -1) {
                this.selectedCandidates.splice(index, 1);
                const approvedIndex = this.approvedCandidates.findIndex(item => item.id === userId);
                if (approvedIndex !== -1) {
                    this.approvedCandidates[approvedIndex].is_selected = false;
                } else {
                    console.log('User not found in approvedCandidates');
                }
            } else {
                console.log('User not found in selectedCandidates');
            }
        },
        getNameOfPosition(item) {
            if (item.job_title != '' && item.position_name != '') {
                return `${item.job_title} - ${item.position_name}`;
            } else {
                return item.job_title != '' ? item.job_title : item.position_name;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
label {
  @apply mb-1 block text-sm;
}
.form-input {
    input[type="text"],
input[type="email"],
input[type="number"],
input[type="password"],
input[type="date"],
input[type="datetime-local"],
select {
  @apply block w-full border rounded-lg py-2 px-2;
}
input[type="text"]:focus,
input[type="email"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="date"]:focus,
input[type="datetime-local"]:focus,
select:focus {
  outline: none;
  border-color: #394867;
  box-shadow: 0 0 0 2px #394867;
}
}
.invalid label {
  @apply text-red-600;
}
.invalid input,
.invalid select {
  border: 1px solid red;
}
input[type="checkbox"] {
  @apply w-auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}
.ht-42 {
    height: 42px;
}
.max-ht-224 {
    max-height: 224px;
}
.rsdfade-enter-active,
.rsdfade-leave-active {
  transition: all 0.3s ease;
}
.rsdfade-enter-from,
.rsdfade-leave-to {
  opacity: 0;
}
</style>